(function () {
	'use strict';

	angular.module('app.leanProjects')
		.controller('viewMetricData', viewMetricData);

	viewMetricData.$inject = ['$scope', '$timeout', '$uibModal', '$rootScope', 'tableService', 'leanFilterService', 
		'viewMetricDataService', 'commentsService', 'tableRenderService', '$state', 'storeService', '$experiments'];

	function viewMetricData($scope, $timeout, $uibModal, $rootScope, tableService, leanFilterService, 
			viewMetricDataService, commentsService, tableRenderService, $state, storeService, $experiments) {
		var vm = this;
		var rendererParams = {
			'controllerName': 'viewMetricData'
		};
		var unsubscribe;

		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;
		var reportSettingsName = 'metric-view';

		// Extra query params to send to backend in data requests
		var extraParams = [{
			excelReportName: 'ViewMetricData'
		}];
		var pinnedColumns = [];

		// Set navigation properties
		$timeout(function () {
			jQuery('div.panel-heading').removeClass('selected');
			jQuery('h4.panel-title a').removeClass('selected');
			jQuery('li.list-group-item.selected').removeClass('selected');
			jQuery('#viewMetricData').addClass('selected');
		}, 0);

		vm.showExcel = true;

		$scope.filterService = leanFilterService;

		var defaultFilters = [{
			'id': 'factory', 
			'values': [globalConfig.factory.id], 
			'isMandatory': true
		},
		{
			'id': 'metric',
			'values': [$scope.filterService.leanDnaAllSelected]
		},
		{
			'id': 'valueStream',
			'values': [$scope.filterService.leanDnaAllSelected]
		},
		{
			'id': 'metricFrequency',
			'values': [$scope.filterService.leanDnaAllSelected]
		},
		{
			'id': 'currentDate',
			'values': [$scope.filterService.leanDnaAllSelected]
		}
		];
		
		var columns = [{
			'id': 'action',
			'display': 'Action',
			'renderer': tableRenderService.viewMetricDataAction,
			'sort': false,
			'width': '60'
		},
		{
			'id': 'metricName',
			'display': 'Metric',
			'width': 150
		},
		{
			'id': 'valueStreamName',
			'display': 'Value Stream',
			'width': 130
		},
		{
			'id': 'currentDate',
			'display': 'Date',
			'renderer': tableRenderService.dateRenderer,
			'convertTimeZone': true,
			'sortDefaultReverse': true,
			'width': 100
		},
		{
			'id': 'value',
			'display': 'Value',
			'renderer': tableRenderService.metricValueRenderer,
			'sort': false,
			'width': 150
		},
		{
			'id': 'comment',
			'displayText': 'Comment',
			'display': 'Comment <i class="fa fa-flip-horizontal fa-comment"></i>',
			'renderer': tableRenderService.inlineMetricComment,
			'width': 150
		},
		{
			'id': 'category',
			'display': 'Category',
			'width': 100
		},
		{
			'id': 'siteName',
			'display': 'Site',
			'width': 100
		},
		{
			'id': 'ownerName',
			'display': 'Owner',
			'width': 120
		}
		];

		var meta = {
			reportSettingsName: reportSettingsName,
			reportSettingsId: reportSettingsId,
			reportUrl: '{0}/ViewMetricDataReport',
			noPaging: false,
			columns: columns,
			pinnedColumns: pinnedColumns,
			defaultFilters: defaultFilters,
			defaultSort: 'currentDate',
			defaultSortDirection: 'desc',
			extraParams: extraParams,
			rendererParams: rendererParams,
			pageSize: 50,
			setColumnDefaults: true,
			hideSearch: true,
			waitForFilters: true
		};

		vm.getData = getData;
		vm.getMeta = getMeta;
		vm.broadcastExcel = broadcastExcel;
		vm.saveMetricValues = saveMetricValues;
		vm.saveMetricComment = saveMetricComment;
		vm.deleteMetricResult = deleteMetricResult;
		vm.reportName = 'Metric data';
		vm.baseReportDisplay = vm.reportName;

		function navigateToBaseReport() {
			$state.go('.', {reportId: undefined});
		}

		vm.navigateToBaseReport = navigateToBaseReport;
		vm.showEnterMetricData = true;

		if (reportSettingsId) {
			vm.showInfo = true;
			vm.isSavedReport = true;
			vm.reportName = '';
		} else {
			vm.showSaveReport = true;
			vm.isSavedReport = false;
		}

		$scope.$on('reportConfigReady', function () {
			var reportSettings = storeService.getState().reportSettings;
			
			if (reportSettings.viewType === 'savedLeanProjects') {

				vm.userDescription = reportSettings.userDescription;
				vm.reportName = storeService.getState().reportSettings.reportName;
				unsubscribe = storeService.subscribe(function () {
					var state = storeService.getState();
					if (state.reportSettings.reportName !== vm.reportName) {
						vm.reportName = state.reportSettings.reportName;
					}
					if (state.reportSettings.userDescription !== vm.userDescription) {
						vm.userDescription = state.reportSettings.userDescription;
					}
				});
			}
		});
		if (reportSettingsId) {
			$scope.$on('reportConfigFailed', function() {
				navigateToBaseReport();
			});
		}

		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			return tableService.getData(params, extraParams).then(function (response) {
				// If any data manipulation is needed, do it here
				return response;
			});
		}

		function broadcastExcel() {
			$rootScope.$broadcast('export-excel', { doChooseColumns: false });
		}

		function deleteMetricResult (row) {
			var confirmScope = $scope.$new();
			confirmScope.additionalText = 'delete this metric result';
			confirmScope.buttonText = 'Delete';

			var opts = {
				scope: confirmScope,
				templateUrl: '/application/f/core/confirm.html'
			};

			var instance = $uibModal.open(opts);
			confirmScope.closeDialog = function() {
				instance.close();
				confirmScope.$destroy();
			};

			confirmScope.yes = function() {
				instance.close();
				confirmScope.$destroy();
				// set null value to delete an entry
				row.value = null;
				viewMetricDataService.updateMetricEntry(row, new Date(row.currentDate))
					.then(function (notUpdated) {
						if (notUpdated.length === 0) {
							$rootScope.$emit('toast', {'message': 'Metric result deleted successfully', 'success': true});
							$scope.$broadcast('reloadTable');
						}
					});
			};
		};


		function saveMetricValues(row, cell, content) {
			if (row.valueFunction === 'value') {
				row.value = content;
				row.valueA = row.value;
				row.valueB = 1;
			} else {
				row.valueA = content.valueA;
				row.valueB = content.valueB;
				row.value = row.valueA / row.valueB;
				if (row.displayType === 'percentage') {
					row.value *= 100;
				}
			}
			viewMetricDataService.updateMetricEntry(row, new Date(row.currentDate))
				.then(function (notUpdated) {
					if (notUpdated.length === 0) {
						$scope.$broadcast('reloadTable');
					} else {
						cell.children('.errorMsg').html('Update failed, refresh page');
						cell.attr('title', 'Update failed, refresh page');
						row.dateModified = notUpdated[0].dateModified;
						row.currentDate = notUpdated[0].currentDate;
						row.value = notUpdated[0].value;
						row.valueA = notUpdated[0].valueA;
						row.valueB = notUpdated[0].valueB;
						row.hasError = true;
					}
				});
		}

		function saveMetricComment(row, comment) {
			var currentContent = row.comment;
			var value = {};
			value.comment = comment;
			if (row.commentNdx || row.commentNdx === 0) value.ndx = row.commentNdx;
			if (value.ndx || value.ndx == 0 || value.comment) {
				value.leanDirFactoryNdx = row.leanDirFactoryNdx;
				value.metricResultNdx = row.resultNdx;
				value.subType = 'status';
				if (currentContent === value.comment) {
					return;
				}
				commentsService.saveComment(row.leanDirFactoryNdx, 'metric', value)
					.then(function (data) {
						if (data && data.ndx) {
							if (data && data.error) {
								$rootScope.$emit('toast', {'message': data.error, 'success': false});
							} else {
								row.commentNdx = data.ndx;
								row.comment = value.comment;
								$scope.$broadcast('reloadTable');
							}
						}
					});
			}
		}

		function init() {
			leanFilterService.clearFilters();
			$scope.filterService.useFactoryFilter = true;
			var siteFilter = leanFilterService.filterDefinitions['Factory'];
			siteFilter.type = 'multiselect';
			siteFilter.removable = false;
			$scope.filterService.setMasterFilterList([
				$scope.filterService.filterDefinitions.Metric,
				siteFilter,
				$scope.filterService.filterDefinitions.ValueStream,
				$scope.filterService.filterDefinitions.MetricOwner
			]);
			$scope.filterService.setMasterRangeFilterList([
				$scope.filterService.filterDefinitions.CurrentDate
			]);
		}

		init();
	}
})();
